<template>
    <v-dialog persistent v-model="dialog" width="350">
        <v-card max-height="80vh" tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">تنظیم محتوا جدول</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon="close" variant="text"></v-btn>
            </v-toolbar>
            <div class="py-3 px-4 mt-3">
                <switch-input v-for="item in filteredSettings" :label="item.title" :true-value="1" :false-value="0" false-label="" true-label="" v-model="tempSettings[item.key]"></switch-input>
            </div>
            <v-card-actions class="pb-3 px-5">
                <v-btn @click="submit" color="success" variant="flat">ثبت اطلاعات</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" color="error">بستن</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script setup>
const dialog = ref(false);
const { filteredSettings } = defineProps(['filteredSettings'])
const tempSettings = reactive(Object.fromEntries(filteredSettings.map(x => [x.key, x.default])));

const emit = defineEmits(['updated']);
function openDialog(settings) {
    filteredSettings.forEach(el => {
        tempSettings[el.key] = settings[el.key];
    });
    dialog.value = true;
}
function submit() {
    emit('updated', tempSettings);
    dialog.value = false;
}
defineExpose({openDialog})
</script>
